import React from 'react'
import ReactDOM from 'react-dom/client'
import Dashboard from './pages/Dashboard'
import History from './pages/History'
import CssBaseline from '@mui/material/CssBaseline'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import LiveTips from './pages/LiveTips'
import Account from './pages/Account'
import 'moment-timezone'
import { Provider } from 'react-redux'

import { store } from './redux'

import Login from "./pages/Login";
import Register from "./pages/Register";
import Settings from './pages/Settings'
import TipsPage from './pages/TipsPage'
import PreMatch from './pages/PreMatch'
import MyFilters from "./pages/MyFilters";

import Layout from './components/layout'

import PrivateRoute from './privateRoute'

import './index.css'
import Filter from "./pages/Filter";

let Wrap = process.env.NODE_ENV === 'development' ? React.StrictMode : React.Fragment

if (process.env.NODE_ENV === 'development') {
    window.localStorage.setItem('is_dev', 'true')
}

const theme = createTheme({
    palette: {
        // @ts-ignore
        black: {
            main: '#000000'
            // darker: '#053e85',
        },
        white: {
            main: '#ffffff'
            // darker: '#ffffff',
        },
        primary: {
            main: '#ee7c31'
            // darker: '#053e85',
        },
        win: {
            main: '#4caf50'
            // darker: '#053e85',
        },
        lost: {
            main: '#f44336'
            // darker: '#053e85',
        },
        pending: {
            main: '#ee7c31'
            // darker: '#053e85',
        },
        secondary: {
            // green
            main: '#00b050'
            // darker: '#053e85',
        },
        neutral: {
            main: '#ee7c31'
            // contrastText: '#fff',
        }
    }
})
Wrap = React.Fragment

// @ts-ignore
ReactDOM.createRoot(document.getElementById('root')).render(
    <Wrap>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <CssBaseline enableColorScheme />
                <BrowserRouter>
                    <Routes>
                        <Route path='/' element={<Layout><LiveTips /></Layout>} />
                        <Route path='/login' element={<Login />} />
                        <Route path='/register' element={<Register />} />
                        <Route path='/statistics' element={<Layout><Dashboard /></Layout>} />
                        <Route path='/tips' element={<Layout><TipsPage /></Layout>} />
                        <Route path='/pre-match' element={<Layout><PreMatch /></Layout>} />
                        <Route path='/my-filters' element={<Layout><MyFilters /></Layout>} />
                        <Route path='/my-filters/new' element={<Layout><Filter /></Layout>} />
                        <Route path='/settings' element={<Layout><Settings /></Layout>} />
                        <Route path='/football/match/:matchId' element={<Layout><LiveTips /></Layout>} />
                        <Route path='/account' element={<PrivateRoute><Layout><Account /></Layout></PrivateRoute>} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </BrowserRouter>
            </ThemeProvider>
        </Provider>
    </Wrap>
)

const onPerfEntry = ({ name, delta, id }: any) => {
    // @ts-ignore
    if (!window.gtag) {
        return
    }
    // @ts-ignore
    return window.gtag('event', name, {
        event_category: 'Web Vitals',
        event_label: id,
        value: Math.round(name === 'CLS' ? delta * 1000 : delta),
        non_interaction: true
    })
}
import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(onPerfEntry)
    getFID(onPerfEntry)
    getFCP(onPerfEntry)
    getLCP(onPerfEntry)
    getTTFB(onPerfEntry)
})